// ==================== WHITEPAPERS PAGE ====================

import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FileText, Mail } from 'lucide-react';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { ROUTES } from '../../constants';
import { fadeInUp, staggerContainer } from '../../utils/animations';

const WhitepapersPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <section className="relative py-24 lg:py-32 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-linear-to-b from-(--color-midnight-navy) via-(--color-dark-navy) to-(--color-midnight-navy)" />
        <motion.div
          className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-(--color-signal-orange)/10 rounded-full blur-3xl"
          animate={{ scale: [1, 1.1, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity }}
        />

        <div className="container-custom relative z-10">
          <motion.div
            className="text-center max-w-2xl mx-auto"
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
          >
            <motion.div
              className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-(--color-orange-glow) mb-6"
              variants={fadeInUp}
            >
              <FileText size={32} className="text-(--color-signal-orange)" />
            </motion.div>

            <motion.div variants={fadeInUp}>
              <Badge variant="orange" className="mb-4">Coming Soon</Badge>
            </motion.div>

            <motion.h1
              className="text-4xl lg:text-5xl font-heading font-bold text-white mb-4"
              variants={fadeInUp}
            >
              Whitepapers
            </motion.h1>

            <motion.p
              className="text-lg text-(--color-soft-gray) mb-10"
              variants={fadeInUp}
            >
              We're preparing in-depth whitepapers on WhatsApp Business messaging, AI-powered
              lead generation and customer engagement. Check back soon.
            </motion.p>

            <motion.div variants={fadeInUp}>
              <Link to={ROUTES.CONTACT}>
                <Button variant="secondary" size="lg" leftIcon={<Mail size={18} />}>
                  Contact Us
                </Button>
              </Link>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export { WhitepapersPage };
